import { axiosServices } from "./axiosServices";

export const onboardingServices = {
  getFormStepWise,
  getAdminStep,
  getAdminStepsById,
  createStepField,
  updateStepField,
  uploadFile,
  viewUrlData,
  updateObForm,
  getFormProgress,
  submitObForm,
  submitCheckListForm,
  submitLastStepDetails,
  submitSAPCreation,
  initiateVerification
};

function getFormStepWise(param) {
  return axiosServices
    .getAxios(`/v1/vendor/onboarding/get-form${param}`)
    .then((res) => {
      return res;
    });
}

function getAdminStep(param) {
  return axiosServices.getAxios(`/v1/admin/steps${param}`).then((res) => {
    return res;
  });
}

function getAdminStepsById(param, param2) {
  return axiosServices.getAxios(`/v1/admin/steps/${param}${param2}`).then((res) => {
    return res;
  });
}

function getFormProgress(id) {
  return axiosServices
    .getAxios(`/v1/common/vendors/form-progress?vendorId=${id}`)
    .then((res) => {
      return res;
    });
}


function viewUrlData(id, fileNameParam) {
  return axiosServices
    .getAxios(`/v1/common/sub/upload?key=${id}&fileName=${fileNameParam}`)
    .then((res) => {
      return res;
    });
}

function createStepField(bodyData, stepId) {
  return axiosServices
    .postAxios(`/v1/admin/steps/${stepId}/fields`, bodyData)
    .then((res) => {
      return res;
    });
}

function uploadFile(bodyData) {
  return axiosServices
    .postAxios(`/v1/common/sub/upload`, bodyData)
    .then((res) => {
      return res;
    });
}

function updateObForm(bodyData) {
  return axiosServices
    .postAxios(`/v1/vendor/onboarding/update-form`, bodyData)
    .then((res) => {
      return res;
    });
}

function submitObForm(bodyData) {
  return axiosServices
    .postAxios(`/v1/vendor/onboarding/submit-form`, bodyData)
    .then((res) => {
      return res;
    });
}

function submitCheckListForm(bodyData) {
  return axiosServices
    .postAxios(`/v1/engineering/factory-visit/checklist`, bodyData)
    .then((res) => {
      return res;
    });
}

function initiateVerification(bodyData) {
  return axiosServices
    .postAxios(`/v1/internal/steps/initiate-verification`, bodyData)
    .then((res) => {
      return res;
    });
}

function submitLastStepDetails(bodyData) {
  return axiosServices
    .postAxios(`/v1/internal/steps/submit-details`, bodyData)
    .then((res) => {
      return res;
    });
}

function submitSAPCreation(bodyData) {
  return axiosServices
    .postAxios(`/v1/internal/vendors/initiate-sap-creation`, bodyData)
    .then((res) => {
      return res;
    });
}

function updateStepField(bodyData, stepId) {
  return axiosServices
    .putAxios(`/v1/admin/steps/${stepId}/fields`, bodyData)
    .then((res) => {
      return res;
    });
}
